<script setup lang="ts" generic="T extends SelectInputType">
import { computed } from 'vue';

import type { IFormSelectButtonInputOption, SelectInputType } from '@modules/forms/types';
import VFormSelectButtonInput from '@modules/forms/components/inputs/VFormSelectButtonInput/VFormSelectButtonInput.vue';
import VFormErrorTag from '@modules/forms/components/VFormErrorTag/VFormErrorTag.vue';

import type {
  VFormSelectButtonTaggedErrorWidgetEmits,
  VFormSelectButtonTaggedErrorWidgetProps,
} from './types';

const props = withDefaults(defineProps<VFormSelectButtonTaggedErrorWidgetProps<T>>(), {});
const emit = defineEmits<VFormSelectButtonTaggedErrorWidgetEmits<T>>();

const selectButtonInputProps = computed(() => {
  const { errors, steps, ...input } = props;

  return input;
});

const productOptions = computed<IFormSelectButtonInputOption<T>[]>(() => props.options.map((item) => ({
  ...item,
  showDeleteButton: !!props.steps.filter((step) => step.value.product === item.value)?.length && !props.hideDeleteButton,
})));
</script>

<template>
  <div v-data-qa-auto-id="'VFormSelectButtonTaggedErrorWidget'" class="flex items-start gap-4 max-sm:flex-col max-sm:items-center">
    <VFormSelectButtonInput
      v-bind="selectButtonInputProps"
      :options="productOptions"
      @change="emit('change', $event)"
      @input="emit('input', $event)"
      @blur="emit('blur', $event)"
      @focus="emit('focus', $event)"
      @delete="emit('delete', $event)"
    />

    <VFormErrorTag
      class="mt-1.5"
      :errors="errors"
    />
  </div>
</template>
